import type { ReactNode } from 'react';
import { PremiumCard } from './PremiumCard';

export function MealSectionCard({
  title,
  meals,
  onAdd,
  children,
}: {
  title: string;
  meals: number;
  onAdd: () => void;
  children: ReactNode;
}) {
  return (
    <PremiumCard className="!p-3 sm:!p-4">
      <div className="mb-2 flex items-center justify-between gap-2">
        <div>
          <h3 className="font-display text-sm font-bold text-white">{title}</h3>
          <p className="text-[10px] text-zinc-500">{meals} logged</p>
        </div>
        <button
          type="button"
          onClick={onAdd}
          className="btn-press flex h-9 w-9 items-center justify-center rounded-xl bg-accent text-lg font-semibold text-white"
          aria-label={`Add ${title}`}
        >
          +
        </button>
      </div>
      {children}
    </PremiumCard>
  );
}
